// Magaza linkleri — TEK kaynak (Hero, DownloadCTA). iOS App Store'da canli (Apple ID 6793705970).
export const APP_STORE_URL = 'https://apps.apple.com/tr/app/mahallebi-mahalle-pazar%C4%B1/id6793705970';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.mahallebi.tr&hl=tr';
